(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (!section) return;
    if (prefersReducedMotion.matches) return;

    const enabled = section.dataset.autoScroll === 'true';
    if (!enabled) return;

    // Dawn typically uses a horizontally scrollable container for product lists
    const scroller =
      section.querySelector('.slider') ||
      section.querySelector('.product-grid') ||
      section.querySelector('[role="list"]');

    if (!scroller) return;

    // Only run if it can actually scroll horizontally
    if (scroller.scrollWidth <= scroller.clientWidth + 2) return;

    const speedSetting = Number(section.dataset.autoScrollSpeed || 4); // 1..10
    const pxPerFrame = 0.2 * speedSetting; // gentle by default

    let rafId = null;
    let paused = false;

    const tick = () => {
      if (!paused) {
        scroller.scrollLeft += pxPerFrame;

        // Loop back near the end
        const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
        if (scroller.scrollLeft >= maxScrollLeft - 1) {
          scroller.scrollLeft = 0;
        }
      }
      rafId = requestAnimationFrame(tick);
    };

    const pause = () => (paused = true);
    const resume = () => (paused = false);

    // Pause on hover (desktop) and on focus within (keyboard accessibility)
    section.addEventListener('mouseenter', pause);
    section.addEventListener('mouseleave', resume);
    section.addEventListener('focusin', pause);
    section.addEventListener('focusout', resume);

    // Stop if reduced-motion toggles on
    const motionHandler = () => {
      if (prefersReducedMotion.matches && rafId) cancelAnimationFrame(rafId);
    };
    prefersReducedMotion.addEventListener?.('change', motionHandler);

    tick();
  }

  // Initialise on load + Shopify theme editor
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-auto-scroll="true"]').forEach(init);
  });

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target;
    if (section && section.matches('[data-auto-scroll="true"]')) init(section);
    else section?.querySelectorAll?.('[data-auto-scroll="true"]').forEach(init);
  });
})();